// extracted by mini-css-extract-plugin
export default {"page404":"styles_page404__iIs2l","NotFoundImg":"styles_NotFoundImg__gihTP","BTNGroup":"styles_BTNGroup__WgYRS"};